(function ($) {
  const testimonials = document.querySelectorAll('.testimonials-block__slick');

  if (!testimonials) {
    return;
  }

  testimonials.forEach(slider => {
    $(slider).slick({
      dots: true,
      nextArrow: $('.testimonials-block .arrow.next'),
      prevArrow: $('.testimonials-block .arrow.prev')
    });
  });
})(jQuery);
